import { styled } from 'theme'

export const StyledAssignmentTable = styled.div`
  background-color: white;
  .ant-table table {
    border-collapse: collapse;
  }
`
